import React, { useState } from "react";
import { Dialog, Classes } from "@blueprintjs/core";
import Endpoints from "../../../endpoints.js";

/**
 *
 * @param {Object} props
 * @param {Agente} props.currentAgent
 * @returns {JSX.Element}
 * @constructor
 */
export default function SearchClientDialog(props) {
  const [query, setQuery] = useState("");
  const [fullName, setFullName] = useState("");
  const [msg, setMsg] = useState("");
  const [contacts, setContacts] = useState([]);

  //const [contacts, setContacts] = useState([{"numeroClienteIde":"001234","numeroCliente":"004321","nombreCompleto":"FULANITO PEREZ JUAREZ","nombres":"FULANITO","apellidoPaterno":"PEREZ","apellidoMaterno":"JUAREZ","tipoPersona":"Persona Fisica Sin Actividad Empresarial","numeroPersona":"00012354","idPromotorOrigen":"999999","idPromotorAtiende":"000243","estatusCliente":"Activo","telefonoCasa":"81-12-34-56","telefonoCelular":"81 14134670","email":"correo@correo.com"},{"numeroClienteIde":"001235","numeroCliente":"004321","nombreCompleto":"FULANITO PEREZ JUAREZ","nombres":"FULANITO","apellidoPaterno":"PEREZ","apellidoMaterno":"JUAREZ","tipoPersona":"Persona Fisica Sin Actividad Empresarial","numeroPersona":"00012354","idPromotorOrigen":"999999","idPromotorAtiende":"000243","estatusCliente":"Activo","telefonoCasa":"81-12-34-56","telefonoCelular":"81 14134670","email":"correo@correo.com"}]);
  const [loading, setLoading] = useState(false);

  const tipo = "busca-clientes";

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    console.log(props.currentAgent.email);

    fetch(
      Endpoints().GCP_CLIENTS_FINDER(
        query,
        fullName,
        props.currentAgent.email,
      ),
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer "+ props.currentAgent.stsTokenManager.accessToken
        },
        method: "GET",
      },
    )
      .then((response) => response.json())
      .then((contactsData) => {
        if(contactsData.status === 404 || contactsData.status === 500) {
          setContacts([]);
          setMsg("No se encontraron clientes con ese número o nombre completo.");
        } else {
          setContacts(contactsData);
          setMsg("");
        }
      })
      .catch((err) => {
        console.error(err);
        setContacts([]);
        setMsg("Ocurrió un error al buscar los clientes. Intenta de nuevo.");
      })
      .finally(() => setLoading(false));
  };

  const handleSearch = (e) => {
    setQuery(e.target.value.trim().toUpperCase());
  };

  const handleFullNameSearch = (e) => {
    setFullName(e.target.value.trim().toUpperCase());
  };

  const chooseContact = (contact) => {
    if (
      window.confirm(`¿Estás seguro de contactar a ${contact.nombreCompleto}?`)
    ) {
      setContacts([]);
      props.setClient(contact);
    }
  };

  const renderContact = (c) => {
    return (
      <div
        key={c.nombreCompleto}
        className="list-group-item list-group-item-action"
        onClick={chooseContact.bind(this, c)}
        style={{ cursor: "pointer" }}
      >
        <div className="d-flex w-100 justify-content-between">
          <h5 className="mb-1">{c.nombreCompleto}</h5>
          <small></small>
        </div>
        <p className="mb-1">Telefono: {c.telefonoCelular}</p>
        <p className="mb-1"></p>
      </div>
    );
  };

  const handleClose = () => {
    setContacts([]);
    props.close();
  };

  return (
    <Dialog
      icon="new-person"
      onClose={handleClose}
      title="Nuevo mensaje"
      isOpen={props.isOpen}
    >
      <div className={Classes.DIALOG_BODY}>
        <form onSubmit={handleSubmit}>
          <div className="row align-items-center">
            <div className="col">
              <div className="input-group mb-3 input-group-lg">
                <input
                  onChange={handleSearch}
                  autoFocus={true}
                  title="Al menos 8 numeros"
                  minLength={8}
                  inputMode="numeric"
                  pattern="\d{8,}"
                  type="text"
                  className="form-control"
                  placeholder="Numero de cliente"
                />
              </div>
              <div className="input-group mb-3 input-group-lg">
                <input
                  onChange={handleFullNameSearch}
                  autoFocus={true}
                  title="Al menos 5 caracteres"
                  pattern=".{5,}"
                  type="text"
                  className="form-control"
                  placeholder="Nombre completo"
                />
              </div>
              <div className="input-group mb-3 input-group-lg">
                <button style={{width: "100%"}} className="btn btn-primary btn-lg" type="submit">
                  Buscar
                </button>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col">
              {loading ? (
                <div className="bp3-progress-bar">
                  <div
                    className="bp3-progress-meter"
                    style={{ width: "100%" }}
                  ></div>
                </div>
              ) : (
                ""
              )}
              <div className="list-group">
                {contacts.map((x) => renderContact(x))}
                {msg && <div className="alert alert-info mt-2">{msg}</div>}
              </div>
            </div>
          </div>
        </form>
      </div>
    </Dialog>
  );
}
